import React, { FC } from 'react'
import styles from './HeadComponent.module.scss'
import { useHistory } from 'react-router-dom';
import logoImg from '@/assets/components/nav-logo.svg'
import { useTranslation } from "react-i18next";
import { CloseOutlined } from '@ant-design/icons';
// import HomeSVG from '@/assets/components/home.svg';
interface IHeadComponentProps{
  isHideHome?: boolean;
  /** Show Exit/Close (X) button for web view; when clicked calls onClose or window.close() */
  showCloseButton?: boolean;
  onClose?: () => void;
}

const HeadComponent: FC<IHeadComponentProps> = (props) => {
  const { isHideHome, showCloseButton, onClose } = props || {};
  const history = useHistory();
  const { t, i18n } = useTranslation();

  const handleClose = () => {
    if (onClose) {
      onClose();
      return;
    }
    if (window.opener) {
      try {
        window.close();
      } catch {
        history.push('/home');
      }
    } else {
      history.push('/home');
    }
  };

  return (
    <div className={styles.containerHead}>
      <div className={styles.headContent}>
        <img
          src={logoImg}
          className={styles.logo}
        />
        <div className={styles.headRight}>
          {showCloseButton && (
            <button
              type="button"
              className={styles.closeBtn}
              onClick={handleClose}
              aria-label={t('Exit')}
            >
              <CloseOutlined />
            </button>
          )}
          {
            !isHideHome && !showCloseButton && (
              <span className={styles.menuLi} onClick={() => history.push('/home')}>
                {t('首页')}
              </span>
            )
          }
        </div>
      </div>
    </div>
  )
}

export default HeadComponent
